module.exports = __webpack_public_path__ + "img/knowledge-s-item-bg-1.d67360e1.png";